import {useStore} from "./useStore";
import {useEffect, useMemo, useState} from "react";
import {Amplify, Auth} from "aws-amplify";
import aws_config from "../modified_aws-export";

Amplify.configure(aws_config);

export const useAuthorization = () => {
  // States
  const [cognitoUser, userInfo, role, permissions] = useStore((state: any) => [
    state.cognitoUser,
    state.userInfo,
    state.role,
    state.permissions,
  ]);
  const [hasVectorizationPermission, setHasVectorizationPermission] = useState<boolean>(false);
  const [hasImageGenerationPermission, setHasImageGenerationPermission] = useState<boolean>(false);

  const checkUserHasVectorizationPermission = async () => {
    const user = await Auth.currentSession();
    const userGroups = user.getIdToken().payload["cognito:groups"] as string[] | undefined;
    return userGroups?.includes(aws_config.cognito_start_vectorization_process_group) ?? false;
  }

  const checkUserHasImageGenerationPermission = async () => {
    const user = await Auth.currentSession();
    const userGroups = user.getIdToken().payload["cognito:groups"] as string[] | undefined;
    return userGroups?.includes(aws_config.cognito_start_image_generation_process_group) ?? false;
  }

  useEffect(() => {
    checkUserHasVectorizationPermission().then(value => setHasVectorizationPermission(value));
    checkUserHasImageGenerationPermission().then(value => setHasImageGenerationPermission(value));
  }, []);

  // Effects
  const loadUserInfo = useStore((state: any) => state.loadUserInfo);

  const loadPermissions = useStore((state: any) => state.loadPermissions);

  const isHotline = useMemo(() => role === "HOTLINE", [role]);

  return {
    cognitoUser,
    userInfo,
    role,
    permissions,
    loadUserInfo,
    loadPermissions,
    isHotline,
    hasVectorizationPermission,
    hasImageGenerationPermission,
    checkUserHasVectorizationPermission,
    checkUserHasImageGenerationPermission
  };
};
